import React from 'react';
import Icon from '../../../components/AppIcon';


const PortfolioAnalytics = ({ performance, assets }) => {
  const profitLossColor = performance?.profitLoss >= 0 ? 'text-success' : 'text-error';
  const roiColor = performance?.roi >= 0 ? 'text-success' : 'text-error';

  return (
    <div className="card">
      <div className="mb-6">
        <h3 className="text-xl font-semibold text-foreground mb-1">Portfolio Analytics</h3>
        <p className="text-sm text-muted-foreground">Performance metrics and insights</p>
      </div>
      {/* Key Metrics */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="TrendingUp" size={16} className="text-primary" />
            <p className="text-xs text-muted-foreground">24h P&L</p>
          </div>
          <p className={`text-xl font-bold ${profitLossColor}`}>
            ${Math.abs(performance?.profitLoss || 0)?.toFixed(2)}
          </p>
          <p className={`text-xs ${profitLossColor}`}>
            {performance?.profitLoss >= 0 ? '+' : '-'}
            {Math.abs(performance?.profitLoss || 0)?.toFixed(2)}
          </p>
        </div>

        <div className="p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Percent" size={16} className="text-accent" />
            <p className="text-xs text-muted-foreground">ROI</p>
          </div>
          <p className={`text-xl font-bold ${roiColor}`}>
            {performance?.roi >= 0 ? '+' : ''}{performance?.roi?.toFixed(2)}%
          </p>
          <p className="text-xs text-muted-foreground">24h return</p>
        </div>

        <div className="p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="PieChart" size={16} className="text-secondary" />
            <p className="text-xs text-muted-foreground">Diversification</p>
          </div>
          <p className="text-xl font-bold text-foreground">
            {performance?.diversificationScore?.toFixed(0)}/100
          </p>
          <p className="text-xs text-muted-foreground">
            {performance?.diversificationScore >= 70 ? 'Excellent' : 
             performance?.diversificationScore >= 50 ? 'Good' : 'Needs improvement'}
          </p>
        </div>

        <div className="p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Layers" size={16} className="text-warning" />
            <p className="text-xs text-muted-foreground">Assets</p>
          </div>
          <p className="text-xl font-bold text-foreground">{assets?.length || 0}</p>
          <p className="text-xs text-muted-foreground">Total holdings</p>
        </div>
      </div>
      {/* Top & Worst Performers */}
      <div className="grid md:grid-cols-2 gap-4">
        <div className="p-4 bg-success/10 border border-success/20 rounded-lg">
          <div className="flex items-center gap-2 mb-3">
            <Icon name="Award" size={18} className="text-success" />
            <p className="text-sm font-semibold text-foreground">Top Performer</p>
          </div>
          {performance?.topPerformer ? (
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div 
                  className="w-8 h-8 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: `${performance?.topPerformer?.color}15` }}
                >
                  <Icon name={performance?.topPerformer?.icon} size={16} color={performance?.topPerformer?.color} />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">{performance?.topPerformer?.symbol}</p>
                  <p className="text-xs text-muted-foreground">{performance?.topPerformer?.name}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm font-bold text-success">
                  +{performance?.topPerformer?.change24h?.toFixed(2)}%
                </p>
                <p className="text-xs text-muted-foreground">
                  ${parseFloat(performance?.topPerformer?.value || 0)?.toFixed(2)}
                </p>
              </div>
            </div>
          ) : (
            <p className="text-sm text-muted-foreground">No data available</p>
          )}
        </div>

        <div className="p-4 bg-error/10 border border-error/20 rounded-lg">
          <div className="flex items-center gap-2 mb-3">
            <Icon name="TrendingDown" size={18} className="text-error" />
            <p className="text-sm font-semibold text-foreground">Worst Performer</p>
          </div>
          {performance?.worstPerformer ? (
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div 
                  className="w-8 h-8 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: `${performance?.worstPerformer?.color}15` }}
                >
                  <Icon name={performance?.worstPerformer?.icon} size={16} color={performance?.worstPerformer?.color} />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">{performance?.worstPerformer?.symbol}</p>
                  <p className="text-xs text-muted-foreground">{performance?.worstPerformer?.name}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm font-bold text-error">
                  {performance?.worstPerformer?.change24h?.toFixed(2)}%
                </p>
                <p className="text-xs text-muted-foreground">
                  ${parseFloat(performance?.worstPerformer?.value || 0)?.toFixed(2)}
                </p>
              </div>
            </div>
          ) : (
            <p className="text-sm text-muted-foreground">No data available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PortfolioAnalytics;
